export enum GENDER {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
}

export enum IDENTITY_DOCUMENT_TYPE {
  HK_ID = 'HK_ID',
  MAINLAND_ID = 'MAINLAND_ID',
  PASSPORT = 'PASSPORT',
}

export enum IDENTITY_TYPE {
  DEPENDANT_VISA_BELOW_18 = 'DEPENDANT_VISA_BELOW_18', // backend use DEPENDANT_VISA_BELOW_18, so here need to let DEPENDANT_VISA_BELOW_18 map to DEPENDANT_VISA_BELOW_18
  DEPENDANT_VISA_UNDER_18 = 'DEPENDANT_VISA_BELOW_18',
  DEPENDANT_VISA_ABOVE_18 = 'DEPENDANT_VISA_ABOVE_18',
  IANG = 'IANG',
  HKID_PERM = 'HKID_PERM',
  HKID_RIGHT_TO_LAND = 'HKID_RIGHT_TO_LAND',
  TTPS = 'TTPS',
  STUDENT_VISA = 'STUDENT_VISA',
  WORK_VISA = 'WORK_VISA',
  OTHER_VISA = 'OTHER_VISA',
  OTHERS = 'OTHERS',

  // ONE_WAY_PERMIT = 'ONE_WAY_PERMIT',
  // QUALITY_MIGRANT_ADMISSION_SCHEME = 'QUALITY_MIGRANT_ADMISSION_SCHEME',
  // CAPITAL_INVESTMENT_ENTRANT_SCHEME = 'CAPITAL_INVESTMENT_ENTRANT_SCHEME',
  // ADMISSION_SCHEME_FOR_THE_SECOND_GENERATION = 'ADMISSION_SCHEME_FOR_THE_SECOND_GENERATION',
  // VISA_LABEL_FOR_UNCONDITIONAL_STAY = 'VISA_LABEL_FOR_UNCONDITIONAL_STAY',
  // RECOGNIZANCE_FORM_HOLDERS = 'RECOGNIZANCE_FORM_HOLDERS',
  // FULL_TIME_EMPLOYMENT_VISA_WORK_PERMIT = 'FULL_TIME_EMPLOYMENT_VISA_WORK_PERMIT',
}

export enum IS_LOCAL {
  LOCAL = 'LOCAL',
  NON_LOCAL = 'NON_LOCAL',
}

export enum NEED_STUDENT_VISA {
  YES = 'YES',
  NO = 'NO',
}

export enum PROVINCE {
  AN_HUI = 'AH',
  BEI_JING = 'BJ',
  CHONG_QING = 'CQ',
  FU_JIAN = 'FJ',
  GUANG_DONG = 'GD',
  GAN_SU = 'GS',
  GUANG_XI = 'GX',
  GUI_ZHOU = 'GZ',
  HE_NAN = 'HA',
  HU_BEI = 'HB',
  HE_BEI = 'HE',
  HAI_NAN = 'HI',
  HEI_LONG_JIANG = 'HL',
  HU_NAN = 'HN',
  JI_LIN = 'JL',
  JIANG_SU = 'JS',
  JIANG_XI = 'JX',
  LIAO_NING = 'LN',
  NEI_MONGOL = 'NM',
  NING_XIA = 'NX',
  QING_HAI = 'QH',
  SI_CHUAN = 'SC',
  SHAN_DONG = 'SD',
  SHANG_HAI = 'SH',
  SHAAN_XI = 'SN',
  SHAN_XI = 'SX',
  TIAN_JIN = 'TJ',
  XIN_JIANG = 'XJ',
  XI_ZANG = 'XZ',
  YUN_NAN = 'YN',
  ZHE_JIANG = 'ZJ',
}

export const REACT_APP_MINIMUM_LENGTH = 8;
